var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSowingOrPlanting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.753 3.95193C7.74168 5.09308 6.18697 8.50544 7.28687 11.5579C7.42074 11.9294 7.69629 12.2318 8.05207 12.3971C8.40556 12.562 8.80903 12.5773 9.17398 12.4411C9.17627 12.4402 9.17857 12.4393 9.18086 12.4388C12.1922 11.2977 13.7469 7.88531 12.647 4.8328C12.5131 4.46137 12.2376 4.15895 11.8818 3.99361C11.526 3.82734 11.1248 3.83568 10.753 3.95193Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25973 11.6665C1.86889 11.6786 1.53438 11.8108 1.27266 12.073C1.01094 12.3347 0.86492 12.69 0.86622 13.0601C0.880952 16.0999 3.36639 18.5851 6.40559 18.5998C6.40776 18.5998 6.40993 18.5998 6.41253 18.5998C6.77997 18.5998 7.13311 18.4538 7.3931 18.1934C7.65481 17.9316 7.80084 17.5763 7.79954 17.2062C7.78437 14.1664 5.29893 11.6812 2.25973 11.6665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72248 4.12242C5.17182 2.49994 4.02626 1.22127 2.4972 0.523125C1.80531 0.207045 1.00212 0.518344 0.661085 1.2361C-0.093833 2.82128 -0.20602 4.58769 0.344189 6.21065C0.894399 7.83361 2.03996 9.1118 3.56946 9.80995C3.91541 9.96823 4.28907 9.96918 4.61893 9.84103C4.94879 9.71288 5.23484 9.45561 5.40558 9.09697C6.1605 7.51227 6.27269 5.74538 5.72248 4.12242Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSowingOrPlanting);
export default __webpack_public_path__ + "static/media/sowing_or_planting.21a16fc46d42bb1cc737f6ac83cf6a80.svg";
export { ForwardRef as ReactComponent };